// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___cjiy","content":"styles_content__G2I1G","row":"styles_row__2--SE","footer":"styles_footer__10v7R","phraseLength":"styles_phraseLength__3eRI0"};